import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import DemoDashboard from './pages/DemoDashboard'
import EpochRewards from './pages/EpochRewards'
import AdminDashboard from './pages/AdminDashboard'

function App() {
  return (
    <div className="app">
      <Routes>
        {/* Public epoch rewards page */}
        <Route path="/rewards" element={<EpochRewards />} />
        <Route path="/epoch" element={<EpochRewards />} />
        
        {/* Admin dashboard with wallet signature auth */}
        <Route path="/admin" element={<AdminDashboard />} />
        
        {/* Demo dashboard route */}
        <Route path="/demo" element={<DemoDashboard />} />
        
        {/* Redirect root to rewards page */}
        <Route path="/" element={<Navigate to="/rewards" replace />} />
        
        {/* Redirect old dashboard route to admin */}
        <Route path="/dashboard" element={<Navigate to="/admin" replace />} />
        
        {/* 404 fallback */}
        <Route path="*" element={<Navigate to="/rewards" replace />} />
      </Routes>
    </div>
  )
}

export default App
